var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMail116X116(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "116px",
    viewBox: "0 0 116 116",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/directmail/116x116") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/directmail/116x116",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "white-circle",
    fill: "#FFFFFF",
    cx: 58.5,
    cy: 58.5,
    r: 52.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(10, 17)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33931343,68.083305 C6.3424796,68.9528765 7.0468505,69.6569835 7.91640475,69.660478 L93.4105444,69.660478 C94.284929,69.6638056 94.9965053,68.9577238 95,68.083305 L95,36.4197341 C95,26.7983148 87.2081161,19.0050843 77.5870015,19.0061614 L23.6378884,19.0121457 C14.0091584,19.1420039 6.33931343,26.875392 6.33931343,36.4195545 L6.33931343,68.083305 Z",
    id: "path26376",
    fill: "#875EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9120756,68.083305 L45.9120756,93.4104514 C45.9089194,94.2897175 46.6223304,95.0033394 47.5015429,95 L56.9919562,95 C57.8711818,95.0032796 58.5847867,94.2897175 58.5814415,93.4104514 L58.5814415,68.083305 L45.9120756,68.083305 Z",
    id: "path26426",
    fill: "#067A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43133243,28.4999965 C2.08013038,28.4999965 0,30.3052655 0,32.6747897 L0,55.9918261 C0,58.3613503 2.08013038,60.1666193 4.43133243,60.1666193 L22.1659442,60.1666193 L39.9005553,60.1666193 C42.2517641,60.1666193 44.3318945,58.3613503 44.3318945,55.9918261 L44.3318945,32.6747897 C44.3318945,30.3052655 42.2517641,28.4999965 39.9005553,28.4999965 L22.1659442,28.4999965 L4.43133243,28.4999965 Z",
    id: "path26398",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1467807,39.9619919 L1.42977697,56.6407583 C0.698608796,57.2609661 0.681985143,58.3835518 1.39447103,59.0251234 C2.20260006,59.7549028 3.28277028,60.1705091 4.43325272,60.1705091 L22.1633584,60.1705091 L39.9051576,60.1705091 C41.0556813,60.1705091 42.1358403,59.7546036 42.9439395,59.0251234 C43.6535111,58.3801408 43.6315323,57.2574354 42.8972638,56.6407583 L23.1921078,39.9619919 C22.4088472,39.2990566 21.7581767,39.4449526 21.1467807,39.9619919 Z",
    id: "path26406",
    fill: "#FCB043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43133243,28.4999965 C3.2808135,28.4999965 2.19964997,28.9147051 1.39156272,29.6441853 C1.05368359,29.950585 0.864334895,30.3878072 0.871788973,30.843868 C0.879692683,31.2999288 1.08365327,31.7305283 1.43165591,32.0253787 L21.1422867,48.7091121 C21.7329216,49.209523 22.5987675,49.209523 23.1894024,48.7091121 L42.9001302,32.0253787 C43.2481328,31.7305283 43.4520934,31.2999288 43.4599971,30.843868 C43.4674512,30.3878072 43.2781025,29.950585 42.9402234,29.6441853 C42.1322301,28.9144059 41.051085,28.4999965 39.9005589,28.4999965 L22.1659442,28.4999965 L4.43133243,28.4999965 Z",
    id: "path26402",
    fill: "#FFCE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.752312,19.0061614 C33.3734422,19.0061614 41.1684144,26.7983148 41.1684144,36.4197341 L41.1684144,68.083305 C41.1649186,68.9577185 40.4533436,69.6637837 39.5789576,69.6604661 L93.4105444,69.6604661 C94.2849299,69.663783 94.9965042,68.957718 95,68.083305 L95,36.4197341 C95,26.7983148 87.2081161,19.0061614 77.5870015,19.0061614 L23.752312,19.0061614 Z",
    id: "path26383",
    fill: "#07A0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.328188,0 C62.4586197,0.00346943067 61.7545534,0.707553065 61.7510775,1.57714941 L61.7510775,36.4197341 L64.9176436,36.4197341 L64.9176436,12.669737 L77.5870015,12.669737 C78.4613957,12.6662378 79.1674391,11.9546232 79.1641058,11.0802002 L79.1641058,1.57714941 C79.1606181,0.707560037 78.4565628,0.00347926202 77.5870015,0 L63.328188,0 Z",
    id: "path26420",
    fill: "#F41381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.328188,34.8301973 C59.8492242,34.8301973 56.9919562,37.6876174 56.9919562,41.1666217 C56.9919562,44.6456858 59.8492242,47.4999941 63.328188,47.4999941 C66.8071338,47.4999941 69.6613141,44.6456858 69.6613141,41.1666217 C69.6613141,37.6876174 66.8071338,34.8301973 63.328188,34.8301973 Z",
    id: "path26412",
    fill: "#D9D9D9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMail116X116);
export default __webpack_public_path__ + "static/media/direct-mail_116x116.1de932c83fdc5d3c9b4aaf3ff30d1413.svg";
export { ForwardRef as ReactComponent };